import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dni-entry',
  templateUrl: './dni-entry.component.html'
})
export class DniEntryComponent {
  @Input() dni: string = '';
  @Output() dniChange = new EventEmitter<string>();

  @Output() loginClick = new EventEmitter<void>();
  @Output() continuarClick = new EventEmitter<string>();

  onDniInput(value: string) {
    this.dni = value;
    this.dniChange.emit(value);
  }
}
